<template>
    <div class="tabs-container">
        <DxTabs :data-source="tabs" v-model:selected-index="selectedIndex" @option-changed="onTabChanged"
            :item-template="tabTemplate" />
        <div v-if="selectedIndex === 0">
            <GridTabContacte @select-contact="onContactSelected" />
        </div>
        <div v-if="selectedIndex === 1">
            <GridContactDetalii :contact="selectedContact" @back="selectedIndex = 0" />
        </div>
    </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import { DxTabs } from 'devextreme-vue/tabs';
import GridTabContacte from './GridTabContacte.vue';
import GridContactDetalii from './GridContactDetalii.vue';
import CrmContacts from '@/services/Comercial/CrmContacts';
import DataSource from 'devextreme/data/data_source';
import AppSetting from '@/settings/appSettings';

export default defineComponent({
    components: {
        DxTabs,
        GridTabContacte,
        GridContactDetalii
    },
    data() {
        return {
            tabs: [
                { text: 'Contacte' },
                { text: 'Detalii' },
            ],
            selectedIndex: 0,
            selectedContact: null
        };
    },
    mounted() {
        if (this.$route.query.contactId) {
            const id = this.$route.query.contactId as string;
            this.fetchContact(id);
        }
    },

    watch: {
        '$route.query.contactId': {
            handler(newId) {
                if (newId) {
                    this.fetchContact(newId as string);
                }
            },
            immediate: true
        }
    },
    methods: {
        onTabChanged(e: any) {
            this.selectedIndex = e.component.option('selectedIndex');
        },
        tabTemplate(itemData: any) {
            return `<div>${itemData.text}</div>`;
        },
        onContactSelected(contact: any) {
            this.selectedContact = contact;
            this.selectedIndex = 1;
        },
        fetchContact(id: string) {
            const ds = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_ComercialOdata + 'CRM_Contacts',
                    key: 'ID',
                    keyType: 'Guid',
                    version: 4,
                    beforeSend: (e: any) => {
                        e.headers = {
                            'Content-Type': 'application/json',
                            Authorization: 'Bearer ' + localStorage.getItem('ERA_Jwt'),
                        };
                        e.params.$expand = 'Account($select=Nume),Tara($select=Nume),Localitate($select=Localitate),Judet($select=Nume)';
                    },
                },
                filter: ['ID', '=', id],
            });

            ds.load().then((response) => {
                if (response && response.length > 0) {
                    this.selectedContact = response[0];
                    this.selectedIndex = 1;
                }
            }).catch(error => {
                console.error("Error fetching contact:", error);
            });
        }
    }

});
</script>
<style scoped></style>